import { theme } from '@pocketlaw/tetris';
export const RECHARTS_FONT_SIZE = 12;
export const TOOLTIP_CURSOR_FILL = theme.swatches.warm[50];
export const MIN_RECHART_HEIGHT = 200;
